import Marquee from "react-fast-marquee";
import ScrollReveal from "../ScrollReveal";
import { STATS } from "../../data/content";

const RIBBON = [
  "150+ Projects Delivered",
  "60+ Brands Scaled",
  "5 Years of Obsession",
  "3–5 Days Turnaround",
  "Engineered in Obsidian",
];

export const StatsMarquee = () => {
  return (
    <section
      data-testid="stats-marquee-section"
      className="relative py-20 md:py-28 border-t border-white/10 overflow-hidden"
    >
      {/* Ribbon 1 */}
      <Marquee
        gradient={false}
        speed={60}
        className="py-6 border-y border-white/10 bg-[#080808]"
      >
        {RIBBON.concat(RIBBON).map((t, i) => (
          <div
            key={`r1-${i}`}
            className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight mx-8 flex items-center gap-8"
          >
            <span className="text-white">{t}</span>
            <span className="w-2 h-2 bg-white rotate-45" />
          </div>
        ))}
      </Marquee>

      {/* Stats numbers */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
        {STATS.map((s, i) => (
          <ScrollReveal key={s.label} delay={i * 0.08} className="text-center md:text-left">
            <div className="font-display text-5xl md:text-7xl font-black leading-[0.9] tracking-tighter" data-testid={`stat-${i}`}>
              {s.number}
            </div>
            <div className="text-[10px] md:text-xs uppercase tracking-[0.3em] text-white/40 mt-3">
              {s.label}
            </div>
          </ScrollReveal>
        ))}
      </div>

      {/* Ribbon 2 reverse */}
      <Marquee
        gradient={false}
        speed={40}
        direction="right"
        className="py-4 border-y border-white/10 bg-[#050505]"
      >
        {RIBBON.concat(RIBBON).map((t, i) => (
          <div
            key={`r2-${i}`}
            className="font-display text-2xl md:text-4xl font-black uppercase tracking-tight mx-8 flex items-center gap-8 text-outline"
          >
            <span>{t}</span>
            <span className="w-2 h-2 bg-white/40 rotate-45" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default StatsMarquee;
